// This sdk can be used in SSR apps
export const IS_BROWSER = typeof window !== 'undefined';
